import {gsap} from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger'
import {ScrollSmoother} from 'gsap/ScrollSmoother'
import {SplitText} from 'gsap/SplitText'
import 'is-in-viewport'
import {onScroll} from './transition'

gsap.registerPlugin(ScrollSmoother, ScrollTrigger, SplitText)

const matchMedia = gsap.matchMedia()

function allElementsExist() {
  for (const c of arguments) {
    if (!document.querySelector(c)) {
      return false
    }
  }
  return true
}

let startUpscroll = 0
export const scrollSmoother = ScrollSmoother.create({
  smooth: window.matchMedia('(hover: none)').matches ? 0 : 3,
  speed: 1,
  effects: true,
  normalizeScroll: true, // reduces browser scroll inconsistencies
  onUpdate: (self) => onScroll(self),
  onStop: () => onScroll,
})

ScrollTrigger.config({ignoreMobileResize: true})
if (ScrollTrigger.isTouch === 1) {
  ScrollTrigger.normalizeScroll(true)
}

for (const animatedTextElement of gsap.utils.toArray('.animated-text')) {
  let split = SplitText.create(animatedTextElement, {
    type: 'words',
    wordsClass: 'word-inner',
  })

  split.words.forEach((word) => {
    const mask = document.createElement('div')
    mask.classList.add('word-mask')
    mask.style.overflow = 'hidden'
    mask.style.display = 'inline-block'
    word.parentNode.insertBefore(mask, word)
    mask.appendChild(word)
  })

  gsap.set(split.words, {
    display: 'inline-block',
    y: '50%',
    opacity: 0,
  })

  gsap.to(split.words, {
    y: 0,
    opacity: 1,
    duration: 2,
    ease: 'power4.inOut',
    stagger: 0.02,
    scrollTrigger: {
      trigger: animatedTextElement,
      start: 'top 95%',
      once: true,
    },
  })
}

const hero = document.querySelector('#block-0.block-heroBlock')

if (hero) {
  ScrollTrigger.create({
    trigger: hero,
    start: 'top top',
    end: () => `+=${hero.offsetHeight}`,
    pin: true,
    pinSpacing: false,
    scroller: '#smooth-wrapper',
  })
}

// const stickToTopElements = gsap.utils.toArray('.stick-to-top')
//
// if (stickToTopElements.length) {
//   stickToTopElements.forEach((stickToTopElement, i) => {
//     gsap.set(stickToTopElement, {zIndex: i + 1})
//
//     if (i === stickToTopElements.length - 1) return
//
//     ScrollTrigger.create({
//       trigger: stickToTopElement,
//       start: 'top+=1 top',
//       end: () => `+=${stickToTopElement.offsetHeight}`,
//       pin: true,
//       pinSpacing: false,
//       // markers: true,
//     })
//   })
// }

const videoContainer = document.querySelector('.block-featuredVideoBlock')
const video = videoContainer?.querySelector('video')
const audioToggle = videoContainer?.querySelector('.audio-toggle')

if (videoContainer && video) {
  video.muted = true

  ScrollTrigger.create({
    trigger: videoContainer,
    start: 'top bottom',
    end: 'bottom top',
    onEnter: () => video.play().catch(() => {}),
    onLeave: () => video.pause(),
    onEnterBack: () => video.play().catch(() => {}),
    onLeaveBack: () => video.pause(),
  })

  audioToggle?.addEventListener('click', () => {
    video.muted = !video.muted
    audioToggle.querySelector('.sound-on').classList.toggle('hidden', !video.muted)
    audioToggle.querySelector('.sound-off').classList.toggle('hidden', video.muted)
  })
}

// const apartmentsContainer = document.querySelector('.block-apartmentsBlock')
// const apartments = apartmentsContainer?.querySelectorAll('.apartment')
//
// if (apartmentsContainer && apartments?.length) {
//   matchMedia.add('(min-width: 1024px) and (orientation: landscape)', () => {
//     gsap.timeline({
//       scrollTrigger: {
//         trigger: apartmentsContainer,
//         start: () => 'top bottom',
//         end: () => `bottom+=${window.innerHeight} bottom`,
//         // markers: true,
//         snap: {
//           snapTo: (progress, self) => {
//             const increment = 1 / (apartments.length + 1)
//             const exactIndex = progress / increment
//             const currentIndex = Math.floor(exactIndex)
//             const progressInCurrentSlide = exactIndex - currentIndex
//
//             if (self.direction === 1) {
//               return progressInCurrentSlide > 0.33
//                 ? (currentIndex + 1) * increment
//                 : currentIndex * increment
//             } else {
//               return progressInCurrentSlide < 0.67
//                 ? currentIndex * increment
//                 : (currentIndex + 1) * increment
//             }
//           },
//         },
//       },
//     })
//   })
// }
